var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roots)?_c('div',{staticClass:"node-children"},_vm._l((_vm.roots),function(root){return _c('NavigationTreeNode',{key:root.to || root,attrs:{"node":root,"locale-section":_vm.localeSection}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }